(ns ycweb.app.website.dlp.dlp
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.cart.cart :as cart]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.dlp.widgets.articletext :as at]
   [ycweb.app.website.dlp.widgets.badgerow :as br]
   [ycweb.app.website.dlp.widgets.banner :as ba]
   [ycweb.app.website.dlp.widgets.blockquote :as bq]
   [ycweb.app.website.dlp.widgets.brandreviews :as bre]
   [ycweb.app.website.dlp.widgets.brandsbox :as brandsbox]
   [ycweb.app.website.dlp.widgets.buttonrow :as bur]
   [ycweb.app.website.dlp.widgets.calloutpanel :as cop]
   [ycweb.app.website.dlp.widgets.calltoaction :as cta]
   [ycweb.app.website.dlp.widgets.comparisoncard :as compcard]
   [ycweb.app.website.dlp.widgets.competition :as cmpt]
   [ycweb.app.website.dlp.widgets.header :as hd]
   [ycweb.app.website.dlp.widgets.horizontalspacer :as hs]
   [ycweb.app.website.dlp.widgets.html :as hb]
   [ycweb.app.website.dlp.widgets.huntcompetition :as huntcomp]
   [ycweb.app.website.dlp.widgets.infocards :as infocards]
   [ycweb.app.website.dlp.widgets.infotext :as infotext]
   [ycweb.app.website.dlp.widgets.matrix3column :as m3]
   [ycweb.app.website.dlp.widgets.mobilecarousel :as mc]
   [ycweb.app.website.dlp.widgets.mostgifted :as mg]
   [ycweb.app.website.dlp.widgets.mostpopular :as mp]
   [ycweb.app.website.dlp.widgets.newarrivals :as na]
   [ycweb.app.website.dlp.widgets.personalrecommendations :as pr]
   [ycweb.app.website.dlp.widgets.promobanner :as promobanner]
   [ycweb.app.website.dlp.widgets.sectiontitle :as st]
   [ycweb.app.website.dlp.widgets.selectedproducts :as sp]
   [ycweb.app.website.dlp.widgets.semisoluscards :as sc]
   [ycweb.app.website.dlp.widgets.simpleimage :as si]
   [ycweb.app.website.dlp.widgets.simplevideo :as sv]
   [ycweb.app.website.dlp.widgets.specials :as spl]
   [ycweb.app.website.dlp.widgets.testimonial :as tm]
   [ycweb.app.website.dlp.widgets.timebasedpromopanel :as tbpp]
   [ycweb.app.website.dlp.widgets.timebasedspecial :as tbs]
   [ycweb.app.website.search.results :as search]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defn render-widget [app-atom page component]
  (case (:name component)
    "articleText" (at/article-text page component)
    "badgeRow" (br/badge-row component)
    "banner" (ba/banner-component app-atom page component)
    "blockquote" (bq/block-quote page component)
    "brandReviews" (bre/brand-reviews app-atom page component)
    "brandsBox" (brandsbox/brands-box app-atom page component)
    "buttonRow" (bur/button-row app-atom page component)
    "callToAction" (cta/call-to-action component)
    "calloutPanel" (cop/callout-panel app-atom page component)
    "comparisonCard" (compcard/comparison-card component)
    "competition" (cmpt/competition app-atom page component)
    "header" (hd/header app-atom page component)
    "horizontalSpacer" (hs/horizontal-spacer component)
    "html" (hb/html-block app-atom page component)
    "infoCards" (infocards/info-cards app-atom page component)
    "huntCompetition" (huntcomp/hunt-competition app-atom page component)
    "infoText" (infotext/info-text component)
    "matrix3Column" (m3/matrix-3-column app-atom page component)
    "mobileCarousel" (mc/mobile-carousel app-atom page component)
    "mostGifted" (mg/most-gifted app-atom page component)
    "mostPopular" (mp/most-popular app-atom page component)
    "newArrivals" (na/new-arrivals app-atom page component)
    "personalRecommendations" (pr/personal-recommendations app-atom page component)
    "promoBanner" (promobanner/promo-banner app-atom page component)
    "sectionTitle" (st/section-title page component)
    "selectedProducts" (sp/selected-products app-atom page component)
    "semisolusCards" (sc/semisolus-cards app-atom page component)
    "testimonial" (tm/testimonial app-atom page component)
    "simpleImage" (si/simple-image app-atom page component)
    "simpleVideo" (sv/simple-video component)
    "specials" (spl/specials app-atom page component)
    "timeBasedPromoPanel" (tbpp/time-based-promo-panel app-atom page component)
    "timeBasedSpecials" (tbs/time-based-specials app-atom page component)
    [:h3 "Widget not ported yet: " (:name component)]))

(rum/defc dlp-full-page < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        dlp-page (cmn/curact process-atom [:dlp-page])
        {:keys [metatitle published_layout]} dlp-page

        header-hide-banner
        (->>
          published_layout
          (filter #(= (:name %) "header"))
          (first)
          (:properties)
          (:header/hide-header-banner)
          (trf/toboolean))

        isarticle? (trf/toboolean (:isarticle dlp-page))]

    (web-common/set-meta-title! metatitle)
    [:main#main-content
     {:class
      (u/bem :yc-page-content
        [(cond
           (or header-hide-banner isarticle?) "medium"
           :else "standard")])}

     (map (partial render-widget app-atom dlp-page) published_layout)

     (when (cmn/has-permission? app-atom "SiteAdmin")
       [:div
        {:class (u/bem :yc-section [:standard])}
        (buttons/button-web "Edit DLP"
          (merge
            (urlstate/href-props app-atom "admin/pagebuilder" "edit" {:id (:id dlp-page)})
            {:size :default}))])]))

(rum/defc dynamic-page < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        page-type (cmn/curact process-atom [:page-type])]

    (cond
      (= page-type :cart)
      (cart/checkout-screen-wrapper app-atom (cart/cart-page app-atom process-atom) {})

      :else
      (website/screen-wrapper app-atom
        (case page-type
          :category (search/results app-atom)
          :brand (search/results app-atom)
          :defined-search (search/results app-atom)
          :pagebuilder (dlp-full-page app-atom)
          ;; Nothing resolved — the receive handler sends a 404 status to match.
          [:main#main-content.yc-page-content.yc-page-content--standard
           [:div.yc-section
            (flow/page-not-found-content)]])
        {:banner-type "Footer Ads" :banner-limit 4}))))

(defmethod flow/render-screen :web.dynamic [app-atom _]
  (dynamic-page app-atom))

(defmethod t/transition-open :web.dynamic [app-atom _ params]
  (let [base (get-in @app-atom [:page :web.dynamic :base])
        transformed-params (search/transform-send-params params)
        cookies (get-in @app-atom [:page :cookies])
        rows (u/parseInt (:num-search-rows cookies))]

    (toaster/open-overlay app-atom :search/results)
    (comms/ajax-post :web.dynamic/page
      {:base base
       :mobile? (cmn/curact app-atom [:mobile?])
       :params
       (dissoc
         (assoc transformed-params
           :rows (if (> rows 0) rows 20))
         (keyword ""))})))

(defmethod comms/receive :web.dynamic/page [app-atom e]
  (cond
    (= :redirect (:page-type e))
    (urlstate/redirect app-atom (:redirect-url e) nil)

    (contains? #{:category :brand :defined-search} (:page-type e))
    (let [app-page (cmn/curact app-atom [:page])
          {:keys [params base]} ((:screen app-page) app-page)
          {:search/keys [result-size max-pages page-number]} (:search e)]

      (if (and (> result-size 0) (> page-number max-pages) (not (zero? (u/parseInt max-pages))))
        (urlstate/redirect app-atom base nil (assoc params :page (u/parseInt max-pages)))
        (search/swap-atom-search-results app-atom e))
      (toaster/close-overlay app-atom :search/results))

    (contains? #{:pagebuilder} (:page-type e))
    (swap! (cmn/process-cursor app-atom) assoc
      :dlp-page (:dlp-page e)
      :page-type (:page-type e))

    :else
    (swap! (cmn/action-cursor app-atom) assoc :page-type (:page-type e))))